export default __webpack_public_path__ + "static/data-free-for-beta-mobile-d3f9162d2faead0356bf5aea82497115.png";